/* ==========================================================================
   LUJE — keep the homepage hero inside the first screen.

   The problem: the hero is sized by aspect ratio (16:10 by default). On any
   window shorter than the resulting height, the overlaid headline and call to
   action — which sit at the bottom of the image — fall below the fold, so the
   first thing a visitor sees is a photograph with no words on it at all.
   Measured at 1440x720: the CTA landed 170px past the bottom of the screen.

   The fix is a max-height cap in CSS. This script supplies the one number CSS
   cannot work out for itself: how much vertical space sits above the hero.

   Why measure the hero's own offset rather than "the header": the theme's
   `--luje-header-h` is set by measuring `.sf-header`, which computes to a
   height of 0 on this theme, so it was reporting 35px when the real space
   above the hero is 111px (35px announcement bar + 76px header). Measuring the
   gap between the top of the viewport and the top of the hero is immune to
   that — it does not care what is up there, how many bars there are, or
   whether one gets dismissed.

   Enhancement only. The CSS carries a sensible fallback, so with JavaScript off
   the hero is still capped, just to an assumed offset rather than a measured
   one.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;

  function measure() {
    var hero = document.querySelector('.luje-home--hero');
    if (!hero) return;

    // Only meaningful at the top of the page: once scrolled, the hero's
    // viewport-relative top is no longer the space above it.
    var offset = Math.round(hero.getBoundingClientRect().top + window.scrollY);
    if (offset < 0) offset = 0;
    if (offset > 400) offset = 400;   // guard against a wild reading

    root.style.setProperty('--lh-hero-offset', offset + 'px');
  }

  function schedule() { requestAnimationFrame(measure); }

  measure();
  document.addEventListener('DOMContentLoaded', measure);
  window.addEventListener('load', measure);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  // The announcement bar is dismissible, and the header can re-render. Watch
  // for anything above the hero changing size.
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(schedule);
    document.querySelectorAll('.header__wrapper, .sf-menu-logo-bar, [class*="announcement"]').forEach(function (el) {
      ro.observe(el);
    });
  }
})();
